
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthenticationLogsModule } from '@/modules/authentication-logs'
import { AuthenticationLogsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'view-authentication-logs-show',
    async setup () {
        const route = useRoute()
        const { getAuthenticationLog } = useAuthenticationLogsModule()
        const authenticationLog = await getAuthenticationLog(route.params.id as string)

        return {
            authenticationLog,
            AuthenticationLogsRouteNames,
            route
        }
    }
})
